import { render, staticRenderFns } from "./PlayGame.vue?vue&type=template&id=45e97364&scoped=true"
import script from "./PlayGame.vue?vue&type=script&lang=js"
export * from "./PlayGame.vue?vue&type=script&lang=js"
import style0 from "./PlayGame.vue?vue&type=style&index=0&id=45e97364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e97364",
  null
  
)

export default component.exports